import { MENU_ITEM_SEPARATOR } from 'ui/menu/menu';

import { assert } from 'cadenza/utils/custom-error';

export class ToolbarStructure {

  // This is a map and not an array because we'll probably need this when we create the buttons from this structure
  // We are able to get a specific actions to create the button from.
  // Also when a button is clicked you can get the action by accessing the map
  _map = new Map();
  _separatorCount = 0;

  set (name, value) {
    assert(!this._map.has(name), 'Do not overwrite toolbar structure items');
    this._map.set(name, value);
  }

  addSeparator () {
    const entries = Array.from(this._map); // Don't use _getEntries() here, because of the extra logic of removing the last visible entry if separator
    if (!isLastEntryASeparator(entries)) {
      this.set(`Separator-${this._separatorCount++}`, MENU_ITEM_SEPARATOR);
    }
  }

  get (name) {
    return this._map.get(name);
  }

  _getEntries () {
    const entries = Array.from(this._map);
    const index = findIndexOfLastVisibleNonSeparatorEntry(entries) + 1;
    return index !== entries.length ? entries.slice(0, index) : entries;
  }

  getValues () {
    return this._getEntries().map(([ , value ]) => value);
  }

  getIndexOfLastNonSeparatorEntry () {
    const entries = Array.from(this._map);
    return findIndexOfLastEntry(entries, entry => entry !== MENU_ITEM_SEPARATOR) + 1;
  }

}

function findIndexOfLastVisibleNonSeparatorEntry (entries) {
  return findIndexOfLastEntry(entries, entry => !(entry === MENU_ITEM_SEPARATOR || entry.hidden));
}

function findIndexOfLastEntry (entries, predicate) {
  for (let i = entries.length - 1; i >= 0; i--) {
    const entry = entries[i][1];
    if (predicate(entry)) {
      return i;
    }
  }
  return -1;
}

function isLastEntryASeparator (entries) {
  return entries.length && isEntryASeparator(entries[entries.length - 1]);
}

function isEntryASeparator ([ , entryValue ]) {
  return entryValue === MENU_ITEM_SEPARATOR;
}

